import * as TFF from '@tff/types/TFF';
import { SsrsByBond, SsrsByPax } from '../../../../types/ancillaryTypes';

export const groupNewSsrsByBound = (
  data: SsrsByPax,
  outboundFlightOnd: string,
  returnFlightOnd: string,
): SsrsByBond => {
  const result: SsrsByBond = {
    outbound: [],
    return: [],
  };

  const addItem = (item: TFF.SsrDetails, flightType: 'outbound' | 'return') => {
    const items = result[flightType];
    const existingItemIndex = items.findIndex(
      existingItem => existingItem.segmentOnd === item.segmentOnd && existingItem.code === item.code,
    );

    if (existingItemIndex !== -1) {
      items[existingItemIndex].amount += item.amount;
    } else {
      items.push({ ...item });
    }
  };

  Object.values(data).forEach(paxArray => {
    paxArray.forEach(item => {
      if (item.code.includes('BA0')) {
        return;
      } else if (item.segmentOnd === outboundFlightOnd) {
        addItem(item, 'outbound');
      } else if (item.segmentOnd === returnFlightOnd) {
        addItem(item, 'return');
      }
    });
  });

  return result;
};
